export const POLL_ENVIRONMENTS_START = 'POLL_ENVIRONMENTS_START';
export type POLL_ENVIRONMENTS_START = typeof POLL_ENVIRONMENTS_START;

export const POLL_ENVIRONMENTS = 'POLL_ENVIRONMENTS';
export type POLL_ENVIRONMENTS = typeof POLL_ENVIRONMENTS;

export const POLL_ENVIRONMENTS_SUCCESS = 'POLL_ENVIRONMENTS_SUCCESS';
export type POLL_ENVIRONMENTS_SUCCESS = typeof POLL_ENVIRONMENTS_SUCCESS;

export const POLL_ENVIRONMENTS_FAILED = 'POLL_ENVIRONMENTS_FAILED';
export type POLL_ENVIRONMENTS_FAILED = typeof POLL_ENVIRONMENTS_FAILED;

export const POLL_ENVIRONMENTS_STOP = 'POLL_ENVIRONMENTS_STOP';
export type POLL_ENVIRONMENTS_STOP = typeof POLL_ENVIRONMENTS_STOP;

export const CLEAR_ENVIRONMENTS = 'CLEAR_ENVIRONMENTS';
export type CLEAR_ENVIRONMENTS = typeof CLEAR_ENVIRONMENTS;

export const DELETE_ENVIRONMENT = 'DELETE_ENVIRONMENT';
export type DELETE_ENVIRONMENT = typeof DELETE_ENVIRONMENT;

export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export type DELETE_PRODUCT = typeof DELETE_PRODUCT;

export const GENERATE_SCALE_OUT_REQUEST = 'GENERATE_SCALE_OUT_REQUEST';
export type GENERATE_SCALE_OUT_REQUEST = typeof GENERATE_SCALE_OUT_REQUEST;

export const GENERATE_SCALE_OUT_REQUEST_SUCCESS =
  'GENERATE_SCALE_OUT_REQUEST_SUCCESS';
export type GENERATE_SCALE_OUT_REQUEST_SUCCESS = typeof GENERATE_SCALE_OUT_REQUEST_SUCCESS;

export const GENERATE_SCALE_OUT_REQUEST_FAILED =
  'GENERATE_SCALE_OUT_REQUEST_FAILED';
export type GENERATE_SCALE_OUT_REQUEST_FAILED = typeof GENERATE_SCALE_OUT_REQUEST_FAILED;

export const GENERATE_ORGANIC_GROWTH_REQUEST =
  'GENERATE_ORGANIC_GROWTH_REQUEST';
export type GENERATE_ORGANIC_GROWTH_REQUEST = typeof GENERATE_ORGANIC_GROWTH_REQUEST;

export const GENERATE_ORGANIC_GROWTH_REQUEST_SUCCESS =
  'GENERATE_ORGANIC_GROWTH_REQUEST_SUCCESS';
export type GENERATE_ORGANIC_GROWTH_REQUEST_SUCCESS = typeof GENERATE_ORGANIC_GROWTH_REQUEST_SUCCESS;

export const GENERATE_ORGANIC_GROWTH_REQUEST_FAILED =
  'GENERATE_ORGANIC_GROWTH_REQUEST_FAILED';
export type GENERATE_ORGANIC_GROWTH_REQUEST_FAILED = typeof GENERATE_ORGANIC_GROWTH_REQUEST_FAILED;

export const GENERATE_UPGRADE_PRODUCT_REQUEST =
  'GENERATE_UPGRADE_PRODUCT_REQUEST';
export type GENERATE_UPGRADE_PRODUCT_REQUEST = typeof GENERATE_UPGRADE_PRODUCT_REQUEST;

export const GENERATE_UPGRADE_PRODUCT_REQUEST_SUCCESS =
  'GENERATE_UPGRADE_PRODUCT_REQUEST_SUCCESS';
export type GENERATE_UPGRADE_PRODUCT_REQUEST_SUCCESS = typeof GENERATE_UPGRADE_PRODUCT_REQUEST_SUCCESS;

export const GENERATE_UPGRADE_PRODUCT_REQUEST_FAILED =
  'GENERATE_UPGRADE_PRODUCT_REQUEST_FAILED';
export type GENERATE_UPGRADE_PRODUCT_REQUEST_FAILED = typeof GENERATE_UPGRADE_PRODUCT_REQUEST_FAILED;

export const DOWNLOAD_ENVIRONMENT_LOGS_REQUEST =
  'DOWNLOAD_ENVIRONMENT_LOGS_REQUEST';
export type DOWNLOAD_ENVIRONMENT_LOGS_REQUEST = typeof DOWNLOAD_ENVIRONMENT_LOGS_REQUEST;

export const EXPORT_CONFIGURATION = 'EXPORT_CONFIGURATION';
export type EXPORT_CONFIGURATION = typeof EXPORT_CONFIGURATION;

export const EXPORT_CONFIGURATION_SUCCESS = 'EXPORT_CONFIGURATION_SUCCESS';
export type EXPORT_CONFIGURATION_SUCCESS = typeof EXPORT_CONFIGURATION_SUCCESS;

export const EXPORT_PRODUCT_CONFIGURATION = 'EXPORT_PRODUCT_CONFIGURATION';
export type EXPORT_PRODUCT_CONFIGURATION = typeof EXPORT_PRODUCT_CONFIGURATION;

export const EXPORT_PRODUCT_CONFIGURATION_SUCCESS =
  'EXPORT_PRODUCT_CONFIGURATION_SUCCESS';
export type EXPORT_PRODUCT_CONFIGURATION_SUCCESS = typeof EXPORT_PRODUCT_CONFIGURATION_SUCCESS;

export const TRIGGER_INVENTORY_SYNC = 'TRIGGER_INVENTORY_SYNC';
export type TRIGGER_INVENTORY_SYNC = typeof TRIGGER_INVENTORY_SYNC;

export const TRIGGER_ENVIRONMENT_INVENTORY_SYNC =
  'TRIGGER_ENVIRONMENT_INVENTORY_SYNC';
export type TRIGGER_ENVIRONMENT_INVENTORY_SYNC = typeof TRIGGER_ENVIRONMENT_INVENTORY_SYNC;

export const TRIGGER_PRODUCT_INVENTORY_SYNC = 'TRIGGER_PRODUCT_INVENTORY_SYNC';
export type TRIGGER_PRODUCT_INVENTORY_SYNC = typeof TRIGGER_PRODUCT_INVENTORY_SYNC;

export const TOGGLE_HEALTH = 'TOGGLE_HEALTH';
export type TOGGLE_HEALTH = typeof TOGGLE_HEALTH;

export const RENAME_ENVIRONMENT = 'RENAME_ENVIRONMENT';
export type RENAME_ENVIRONMENT = typeof RENAME_ENVIRONMENT;

export const UPDATE_ENVIRONMENT = 'UPDATE_ENVIRONMENT';
export type UPDATE_ENVIRONMENT = typeof UPDATE_ENVIRONMENT;

export const UPDATE_ENVIRONMENT_SUCCESS = 'UPDATE_ENVIRONMENT_SUCCESS';
export type UPDATE_ENVIRONMENT_SUCCESS = typeof UPDATE_ENVIRONMENT_SUCCESS;

export const UPDATE_CLUSTER_HEALTH_CHECK_STATUS =
  'UPDATE_CLUSTER_HEALTH_CHECK_STATUS';
export type UPDATE_CLUSTER_HEALTH_CHECK_STATUS = typeof UPDATE_CLUSTER_HEALTH_CHECK_STATUS;
